<template>
    <div class="all_header">
        <div class="home_container">
            <div class="home_top">
                <div class="t_left">
                    <div class="email">
                        <a href="mailto:sales@honengelec.com"><span style="color: #fff; ">sales@honengelec.com</span></a>
                    </div>
                    <div class="phone">
                        +86 755 2643-3662
                    </div>
                    <div @click="globalClick" style="cursor: pointer;">{{$t('h.b2r_10')}}</div>
                </div>
                <div class="t_right">
                    <img @click="changeLangEvent('en')" src="@/pc/assets/home/en.png" alt="">
                    <img @click="changeLangEvent('zh')" src="@/pc/assets/home/zh.png" alt="">
                </div>
            </div>
        </div>
        <div class="home_header">
            <div class="h_left">
                <img src="@/pc/assets/home/logo.png" alt="" @click="titleClick(0)">
            </div>
            <div class="h_right">
                <div class="hr_list">
                    <div :style="{marginLeft:$i18n.locale=='zh'?'50px':'30px'}" class="hr_item" :class="{'hractive':activeIndex == index}"  v-for="(item,index) in titleList" :key="index" @click="titleClick(index)">
                        <div @mouseenter="mouseenter(index)" @mouseleave="mouseleave">
                            {{ item }}
                            <span v-if="index==1">
                                <span v-if="!showItems">
                                    <img src="@/pc/assets/icon/active_bottom.png" alt="" v-if="hoverIndex == index||activeIndex == index">
                                    <img src="@/pc/assets/icon/bottom.png" alt=""  v-else>
                                </span>
                                <span v-else>
                                    <img src="@/pc/assets/icon/active_top.png" alt="" v-if="hoverIndex == index||activeIndex == index">
                                    <img src="@/pc/assets/icon/top.png" alt="" v-else>
                                </span>
                                <div class="hr_citem" :class="{ 'show': showItems }">
                                    <div @click.stop="clickaboutus">{{$t("h.fl1_1")}}</div>
                                    <div @click.stop="clickaboutabracon">{{$t("h.aboutabracon")}}</div>
                                    <div @click.stop="clickjoinus">{{$t("h.fl1_2")}}</div>
                                </div>
                            </span>
                            <span v-if="index==2">
                                <span v-if="!showItemsBrand">
                                    <img src="@/pc/assets/icon/active_bottom.png" alt="" v-if="hoverIndex == index||activeIndex == index">
                                    <img src="@/pc/assets/icon/bottom.png" alt=""  v-else>
                                </span>
                                <span v-else>
                                    <img src="@/pc/assets/icon/active_top.png" alt="" v-if="hoverIndex == index||activeIndex == index">
                                    <img src="@/pc/assets/icon/top.png" alt="" v-else>
                                </span>
                                <div class="hr_citem" :class="{ 'show': showItemsBrand }">
                                    <div @click.stop="clicklinkcard">Top 50 Lines</div>
                                    <div @click.stop="clickputBrand">{{$t("h.fl2_2")}}</div>
                                </div>
                            </span>
                            <span v-if="index==3">
                                <span v-if="!showItemsQuality">
                                    <img src="@/pc/assets/icon/active_bottom.png" alt="" v-if="hoverIndex == index||activeIndex == index">
                                    <img src="@/pc/assets/icon/bottom.png" alt=""  v-else>
                                </span>
                                <span v-else>
                                    <img src="@/pc/assets/icon/active_top.png" alt="" v-if="hoverIndex == index||activeIndex == index">
                                    <img src="@/pc/assets/icon/top.png" alt="" v-else>
                                </span>
                                <div class="hr_citem" :style="{width:$i18n.locale=='zh'?'220px':'360px'}" :class="{ 'show': showItemsQuality }">
                                    <div @click.stop="clickV">{{$t('h.fl3_1')}}</div>
                                    <div @click.stop="clickC">{{$t('h.fl3_2')}}</div>
                                    <div @click.stop="clickQ">{{$t('h.fl3_3')}}</div>
                                    <div @click.stop="clickW">{{$t('h.fl3_4')}}</div>
                                </div>
                            </span>
                            <!-- <span v-if="index==4">
                                <span v-if="!showItemsAppli">
                                    <img src="@/pc/assets/icon/active_bottom.png" alt="" v-if="hoverIndex == index||activeIndex == index">
                                    <img src="@/pc/assets/icon/bottom.png" alt=""  v-else>
                                </span>
                                <span v-else>
                                    <img src="@/pc/assets/icon/active_top.png" alt="" v-if="hoverIndex == index||activeIndex == index">
                                    <img src="@/pc/assets/icon/top.png" alt="" v-else>
                                </span>
                                <div class="hr_citem" :class="{ 'show': showItemsAppli }">
                                    <div @click.stop="clickapplications('1')">{{$t('h.fl4_1')}}</div>
                                    <div @click.stop="clickapplications('2')">{{$t('h.fl4_2')}}</div>
                                </div>
                            </span> -->
                        </div>
                    </div>
                </div>
                <div  class="searchclass" :style="{marginLeft:$i18n.locale=='zh'?'80px':'30px'}">
                    <el-input v-model="queryParams.searchValue" :placeholder="$t('h.KeywordTip')" 
                    @input="handleSearch"
                    @focus="handleSearch"
                    @keyup.enter.native="searchClick"
                    @click.native.stop="handleSearch"
                    ></el-input>
                    <img @click.stop="searchClick" class="searchImg" src="@/pc/assets/search.png" alt="" style="cursor: pointer;">
                    <div class="modellist">
                        <div @click.stop="searchClick(item.modelNum,'搜索选中')" v-for="(item,index) in searchProductList" :key="index" class="modelitem">
                            {{item.modelNum}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import { baseUrl } from '@/utils/env'
export default{
    data() {
        return{
            hoverIndex:'-1',
            showItems:false,
            showItemsBrand:false,
            showItemsQuality:false,
            showItemsAppli:false,
            activeIndex: "",
            queryParams: {
                pageNum: 1,
                pageSize: 9,
                searchValue:undefined
            },
            searchProductList:[]
        }
    },
    created() {
        if(this.$route.meta.currentIndex) {
            this.activeIndex = this.$route.meta.currentIndex
        } else {
            this.activeIndex = parseInt(localStorage.getItem('activeIndex')) || 0
        }
        // 初始化时根据当前路由设置 activeIndex
        this.updateActiveIndex();
        // 只从路由参数获取搜索值，不从 localStorage 获取
        if (this.$route.query.searchValue) {
            this.$set(this.queryParams, 'searchValue', this.$route.query.searchValue);
        } else {
            this.$set(this.queryParams, 'searchValue', undefined);
        }
    },
    watch: {
        // 监听路由变化，更新 activeIndex
        '$route': {
            immediate: true,
            handler(to) {
                this.updateActiveIndex();
                // 路由变化时，只从路由参数获取搜索值
                if (to.query.searchValue) {
                    this.$set(this.queryParams, 'searchValue', to.query.searchValue);
                } else {
                    this.$set(this.queryParams, 'searchValue', undefined);
                }
            }
        }
    },
    computed: {
        // this.$t("h.applications"),
        titleList: function () {
            return [this.$t("h.home"), this.$t("h.aboutus"),this.$t('h.linecard'),this.$t("h.qualitycontrol"), this.$t('h.contactus')]
        },
    },
    mounted() {
        document.addEventListener('click', this.handleDocumentClick);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleDocumentClick);
    },
    methods:{
        handleDocumentClick(event) {
            // 获取搜索框容器
            const searchContainer = event.target.closest('.searchclass');
            // 如果点击不在搜索框区域内，清空下拉列表
            if (!searchContainer) {
                this.searchProductList = [];
            }
        },
        searchClick(modelNum,tipTxt) {
            if(tipTxt=='搜索选中') {
                this.$set(this.queryParams,'searchValue',modelNum)
            }
            if (!this.queryParams.searchValue) {
                return this.$message({
                    type: "info",
                    message: this.$t('h.Keyword')
                });
            }
            // 设置 activeIndex 为 0（首页）
            this.activeIndex = 0;
            localStorage.setItem('activeIndex', 0);

            this.$router.push({name:'prodSearch',query:{ searchValue: this.queryParams.searchValue, pageNum:'1',t:Date.now()}})
            this.searchProductList = []
        },
        loadProductSearch() {
            const apiUrl = `${baseUrl}/api/pms/pmsSelectPrompt`;
            axios.get(apiUrl,{
                params: this.queryParams  // 使用 params 选项
            }).then(response => {
                this.searchProductList = response.data.data
            }).catch(error => {
                
            });
        },
        handleSearch() {
            if (this.queryParams.searchValue && this.queryParams.searchValue.length > 1) {
                this.loadProductSearch();
            } else {
                this.searchProductList = [];
            }
        },
        updateActiveIndex() {
            const routeMap = {
                'home': 0,
                'aboutus': 1,
                'aboutabracon': 1,  // 也属于关于我们
                'joinus': 1,        // 也属于关于我们
                'linecard': 2,
                'putBrand': 2,      // 也属于产品线
                'vdetails': 3,
                'cdetails': 3,      // 也属于质量控制
                'qdetails': 3,      // 也属于质量控制
                'wdetails': 3,      // 也属于质量控制
                'applications': 4,
                'contactus': 4
            };
            
            const routeName = this.$route.name;
            if (routeMap[routeName] !== undefined) {
                this.activeIndex = routeMap[routeName];
                localStorage.setItem('activeIndex', this.activeIndex);
            }
        },
        globalClick() {
            this.$router.push({name:'GTCS'})
        },
        mouseenter(index) {
            this.hoverIndex = index
            if(index==1) {
                this.showItems = true
            } else if (index==2) {
                this.showItemsBrand = true
            } else if (index==3){
                this.showItemsQuality = true
            } 
            // else if (index==4){
            //     this.showItemsAppli = true
            // }
        },
        mouseleave() {
            this.hoverIndex = '-1'
            this.showItems = false
            this.showItemsBrand = false
            this.showItemsQuality = false
            this.showItemsAppli = false
        },
        changeLangEvent(val){
            if (val == "zh"){
                // 切换 Element UI 的语言
                this.$setElementLocale('zh')
                localStorage.setItem("locale", "zh");
                this.$i18n.locale = localStorage.getItem("locale");
                localStorage.setItem("lang", "ZH");
                location.reload(); //重新加载
            } else if (val == "en"){
                this.$setElementLocale('en')
                localStorage.setItem("locale", "en");
                this.$i18n.locale = localStorage.getItem("locale");
                localStorage.setItem("lang", "EN");
                location.reload();
            }
        },
        titleClick(index) {
            this.activeIndex = index
            if(index==0) {
                this.$router.push({name:'home'})
            } else if(index==1) {
                this.$router.push({name:'aboutus'})
            } else if(index==2) {
                this.$router.push({name:'linecard'})
            } else if(index==3) {
                // this.$router.push({name:'qualitycontrol'})
                this.$router.push({name:'vdetails'})
            } 
            // else if(index==4) {
            //     this.$router.push({name:'applications'})
            // } 
            else if(index==4) {
                this.$router.push({name:'contactus'})
            }
            localStorage.setItem('activeIndex', index);
        },
        clickputBrand() {
            this.activeIndex = 2
            localStorage.setItem('activeIndex', 2);
            this.showItemsBrand = false
            this.$router.push({name:'putBrand',query: { tip: '2'}})
        },
        clickapplications(val) {
            this.activeIndex = 4
            localStorage.setItem('activeIndex', 4);
            this.showItemsAppli = false
            this.$router.push({name:'applications',query: { title: val}})
        },
        clickV() {
            this.activeIndex = 3
            localStorage.setItem('activeIndex', 3);
            this.showItemsQuality = false
            this.$router.push({name:'vdetails'})
        },
        clickC() {
            this.activeIndex = 3
            localStorage.setItem('activeIndex', 3);
            this.showItemsQuality = false
            this.$router.push({name:'cdetails'})
        },
        clickQ() {
            this.activeIndex = 3
            localStorage.setItem('activeIndex', 3);
            this.showItemsQuality = false
            this.$router.push({name:'qdetails'})
        },
        clickW() {
            this.activeIndex = 3
            localStorage.setItem('activeIndex', 3);
            this.showItemsQuality = false
            this.$router.push({name:'wdetails'})
        },
        clicklinkcard() {
            this.activeIndex = 2
            localStorage.setItem('activeIndex', 2);
            this.showItemsBrand = false
            this.$router.push({name:'linecard',query: { tip: '1'}})
            // window.location.reload();
        },
        clickaboutus() {
            this.activeIndex = 1
            localStorage.setItem('activeIndex', 1);
            this.showItems = false
            this.$router.push({name:'aboutus',query: { aboutus: '1'}})
            // window.location.reload();
        },
        clickaboutabracon() {
            this.activeIndex = 1
            localStorage.setItem('activeIndex', 1);
            this.showItems = false
            this.$router.push({name:'aboutabracon'})
        },
        clickjoinus() {
            this.activeIndex = 1
            localStorage.setItem('activeIndex', 1);
            this.showItems = false
            this.$router.push({name:'joinus'})
        },
    }
}
</script>
<style lang="scss">
.el-menu.el-menu--horizontal {
    border-bottom:none
}
.all_header{
    top: 0px;
    background: rgb(255, 255, 255);
    position: fixed;
    z-index: 900;
    width: 100%;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 12px;
    .home_container{
        width: 100%;
        height: 45px;
        line-height: 45px;
        background: #123F7A;
        .home_top{
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 1200px;
            margin: 0 auto;
            .t_left{
                display: flex;
                align-items: center;
                font-size: 14px;
                color: #FAFAFA;
                .email{
                    margin-right: 60px;
                    cursor: pointer;
                    a {
                        text-decoration: none;
                    }
                }
                .phone{
                    margin-right: 60px;
                }
            }
            .t_right{
                display: flex;
                align-items: center;
                img{
                    width: 23px;
                    height:23px;
                    margin-left: 20px;
                    cursor: pointer;
                }
            }
        }
    }

    .home_header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 1200px;
        margin: 0 auto;
        padding: 5px 0;
        .h_left{
            img{
                width: 181px;
                height:61px;
                cursor: pointer;
                position: relative;
                top: 4px;
            }
        }
        .h_right{
            display: flex;
            align-items: center;
            .hr_list{
                display: flex;
                align-items: center;
                position: relative;
                .hr_item{
                    text-align: center;
                    height: 14px;
                    font-family: Arial;
                    font-weight: 400;
                    font-size: 16px;
                    color: #000;
                    line-height:14px;
                    cursor: pointer;
                    // margin-left: 50px;
                    height: 30px;
                    line-height: 30px;
                    position: relative;
                    img{
                        width: 11px;
                        height: 8px;
                    }
                    .hr_citem{
                        width: 180px;
                        font-size: 16px;
                        background-color: #fff;
                        color: #000;
                        // padding:20px 0 10px 20px;
                        position: absolute;
                        text-align: left;
                        left:-20px;
                        max-height: 0;
                        overflow: hidden;
                        transition: max-height 0.6s ease;
                        div{
                            margin:10px 0 10px 20px;
                        }
                        div:hover{
                            color:#123F7A;
                        }
                    }
                    .hr_citem.show {
                        max-height: 500px; /* 设置一个足够大的值以容纳内容 */
                    }
                    &:hover{
                        color:#123F7A;
                    }
                }
                
                .hractive{
                    color:#123F7A;
                    border-bottom: 2px solid #123F7A;
                }
            }
            .searchclass{
                position: relative;
                // margin-left: 80px;
                position: relative;
                .el-input__inner{
                    width: 311px;
                    height: 38px;
                    background: #FFFFFF;
                    border-radius: 18px;
                    border-color: #123F7B;
                    font-weight: 400;
                    font-size: 12px;
                }
                .searchImg{
                    width: 50px;
                    height: 30px;
                    position: absolute;
                    right: 5px;
                    top: 4px;
                }
                .modellist{
                    position: absolute;
                    width: 311px;
                    .modelitem{
                        background-color: #fff;
                        height: 35px;
                        line-height: 35px;
                        color: #333333;
                        font-size: 14px;
                        padding-left: 5px;
                        &:hover{
                            // color: #123F7A;
                            cursor: pointer;
                            background-color: #eeeeee;
                        }
                    }
                }
            }
        }
    }
}

</style>